import { render, staticRenderFns } from "./ProblemTwo.vue?vue&type=template&id=5387b6de&scoped=true&"
import script from "./ProblemTwo.vue?vue&type=script&lang=ts&"
export * from "./ProblemTwo.vue?vue&type=script&lang=ts&"
import style0 from "./ProblemTwo.vue?vue&type=style&index=0&id=5387b6de&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5387b6de",
  null
  
)

export default component.exports